import { render } from "./CreativeDetail.vue?vue&type=template&id=7c2f0ccc&scoped=true"
import script from "./CreativeDetail.vue?vue&type=script&lang=js"
export * from "./CreativeDetail.vue?vue&type=script&lang=js"

import "./CreativeDetail.vue?vue&type=style&index=0&id=7c2f0ccc&scoped=true&lang=css"

import exportComponent from "/var/www/html/clientwebview/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2f0ccc"]])

export default __exports__